export interface SafelyFetch {
  url: string
  options?: RequestInit
  returnOnError?: unknown[]
}

export type SafelyFetchFn = (params: SafelyFetch) => Promise<unknown>

export const safelyFetch = async ({ url, options = {}, returnOnError = [] }: SafelyFetch) => {
  try {
    // console.log("safelyFetch", url);
    const response = await fetch(url, options)
    if (response.ok) {
      // All our API endpoints return JSON with this shape
      // {success: true, data: { ... }}
      const data = (await response.json()) as unknown
      if (typeof data !== "object" || !data) {
        throw new Error("Invalid response shape")
      }
      if ("data" in data) {
        return data.data
      }

      throw new Error("Invalid response shape")
    } else {
      console.error("Error fetching", url, response.statusText)
      throw new Error(response.statusText)
    }
  } catch (error) {
    console.error(error)
    return returnOnError
  }
}
